import { render, staticRenderFns } from "./page-list.vue?vue&type=template&id=7f2cf5ea&scoped=true"
import script from "./page-list.vue?vue&type=script&lang=js"
export * from "./page-list.vue?vue&type=script&lang=js"
import style0 from "./page-list.vue?vue&type=style&index=0&id=7f2cf5ea&prod&lang=scss&scoped=true"
import style1 from "./page-list.vue?vue&type=style&index=1&id=7f2cf5ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2cf5ea",
  null
  
)

export default component.exports